module.exports = __webpack_public_path__ + "img/menucn_1_5.5b8505f6.svg";